import { MARQUEE_ITEMS } from "@/data/site";

/**
 * Slow, editorial marquee. Pure CSS animation for buttery performance.
 * Duplicated content + translateX(-50%) creates the seamless loop.
 */
export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section
      className="hairline-t hairline-b overflow-hidden py-6 md:py-8"
      aria-hidden="true"
      data-testid="marquee"
    >
      <div className="mask-fade-r flex w-max animate-marquee items-center gap-16 whitespace-nowrap will-change-transform">
        {items.map((item, i) => (
          <div key={i} className="flex items-center gap-16">
            <span className="font-mono text-sm uppercase tracking-[0.18em] text-muted-ink">
              {item}
            </span>
            <span className="text-accent">/</span>
          </div>
        ))}
      </div>
    </section>
  );
}
